// extracted by mini-css-extract-plugin
module.exports = {"viewMainSubawards":"src-containers-Subaward-Main-styles___viewMainSubawards"};